import axios from "axios";
import { API_BASE_URL } from "../../../config";

function authHeaders() {
  const token = localStorage.getItem("adminToken");
  return { headers: { Authorization: `Bearer ${token}` } };
}

export async function fetchAdminReportedMessages({
  page = 1,
  limit = 20,
  channel = "all",
} = {}) {
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("limit", String(limit));
  if (channel && channel !== "all") params.set("channel", channel);

  const { data } = await axios.get(
    `${API_BASE_URL}/api/website/admin/chat/reported?${params.toString()}`,
    authHeaders()
  );
  return data;
}

export async function dismissAdminChatReport(channel, messageId) {
  const { data } = await axios.patch(
    `${API_BASE_URL}/api/website/admin/chat/reported/${channel}/${messageId}/dismiss`,
    {},
    authHeaders()
  );
  return data;
}
